import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonData, CommonDataType } from '@models/common';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class CommonDataService {
  private commonDataUrl = `${environment.bffUrl}/common-data`;

  constructor(private httpClient: HttpClient) {}

  getAll<T extends CommonDataType>(type?: T): Observable<CommonData<T>[] | CommonData[]> {
    const params = type ? { type } : undefined;
    return this.httpClient.get<CommonData<T>[] | CommonData[]>(this.commonDataUrl, { params });
  }

  getOne(commonDataId: string): Observable<CommonData> {
    return this.httpClient.get<CommonData>(`${this.commonDataUrl}/${commonDataId}`);
  }
}
